import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { AutoLinkedIlok, ClaimedOrder, User } from "../api/models";

export interface GlobalState {
    currentUserId: string | null
    // guest purchases the bootstrap /me materialized — shown once in the
    // ClaimedOrdersBanner, cleared when dismissed
    claimedOrders: ClaimedOrder[]
    // iLok accounts the bootstrap /me linked on its own — shown once in
    // the AutoLinkedIlokBanner, cleared when dismissed
    autoLinkedIlok: AutoLinkedIlok[]
    debug: string
}

const initialState: GlobalState = {
    currentUserId: null,
    claimedOrders: [],
    autoLinkedIlok: [],
    debug: "global state"
}

export const globalSlice = createSlice({
    name: 'global',
    initialState: initialState,
    reducers: {
        logIn: (state, action: PayloadAction<{ user: User, claimedOrders?: ClaimedOrder[], autoLinkedIlok?: AutoLinkedIlok[] }>) => {
            state.currentUserId = action.payload.user.id;
            state.claimedOrders = action.payload.claimedOrders ?? [];
            state.autoLinkedIlok = action.payload.autoLinkedIlok ?? [];
        },
        dismissClaimedOrders: (state) => {
            state.claimedOrders = [];
        },
        dismissAutoLinkedIlok: (state) => {
            state.autoLinkedIlok = [];
        },
        logOut: (state) => {
            state.currentUserId = null;
        },
    }
})

export const meSelector = (state: RootState) => {
    const id = state.global.currentUserId;
    return id ? state.users.entities[id] : undefined;
}

export const { logIn, logOut, dismissClaimedOrders, dismissAutoLinkedIlok } = globalSlice.actions
export const claimedOrdersSelector = (state: RootState) => state.global.claimedOrders
export const autoLinkedIlokSelector = (state: RootState) => state.global.autoLinkedIlok

export default globalSlice.reducer